/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_TitleInputs */

const en_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumes`)
};

const de_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensläufe`)
};

const fr_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums`)
};

const it_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum`)
};

const nl_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV's`)
};

const pl_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelot`)
};

const da_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV'er`)
};

const sv_resumes_title = /** @type {(inputs: Resumes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV:n`)
};

/**
* | output |
* | --- |
* | "Resumes" |
*
* @param {Resumes_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_title = /** @type {((inputs?: Resumes_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_title(inputs)
	if (locale === "fr") return fr_resumes_title(inputs)
	if (locale === "es") return es_resumes_title(inputs)
	if (locale === "it") return it_resumes_title(inputs)
	if (locale === "nl") return nl_resumes_title(inputs)
	if (locale === "pl") return pl_resumes_title(inputs)
	if (locale === "fi") return fi_resumes_title(inputs)
	if (locale === "da") return da_resumes_title(inputs)
	if (locale === "sv") return sv_resumes_title(inputs)
	return en_resumes_title(inputs)
});